/**
 * Source unique des informations d'identification de l'association.
 * Utilisée par les mentions légales, la politique de confidentialité, les CGU,
 * la politique de cookies et le pied de page : une seule valeur à corriger ici.
 *
 * Tout champ "[À COMPLÉTER ...]" doit être rempli avant la mise en ligne
 * (recherche rapide : grep -rn "À COMPLÉTER\|À VÉRIFIER\|À CONFIRMER" src).
 */
export const ASSOCIATION = {
  nom: 'La Bourrée de Paris',
  denominationLegale: 'L\'Association La Bourrée, société folklorique artistique des originaires du Massif Central à Paris',
  formeJuridique: 'Association loi 1901',
  objet: 'Groupe folklorique perpétuant les danses, musiques et chants traditionnels du Massif Central',
  siteUrl: 'https://labourree.com',
  adresseSiege: '41 rue de Lappe, 75011 Paris',
  rna: 'W751010190',
  siret: '788 685 204 00018',
  directeurPublication: 'Julien Laporte, président',
  email: 'contact@labourree.com',
  telephone: '06 15 25 60 99',
  telephoneHref: '+33615256099',
  salleRepetition: '124 rue de Bagnolet, 75020 Paris',
} as const;

export const HEBERGEURS = {
  site: {
    nom: 'Vercel Inc.',
    role: 'Hébergement du site',
    adresse: '440 N Barranca Ave #4133, Covina, CA 91723, États-Unis',
    contact: 'https://vercel.com/contact',
    telephone: 'non communiqué par l\'hébergeur (contact par le formulaire ci-dessus)',
  },
  donnees: {
    nom: 'Google Cloud EMEA Limited (Firebase)',
    role: 'Authentification, base de données et stockage de fichiers',
    adresse: 'Velasco, Clanwilliam Place, Dublin 2, Irlande',
    localisation: 'Les données sont hébergées en Europe.',
  },
} as const;

/** Date de dernière mise à jour des textes juridiques. */
export const DERNIERE_MISE_A_JOUR = '20 septembre 2026';
